import {filterStyles} from "@insite/content-library/Widgets/MyLists/MyListsFilter";
import { css } from "styled-components";

filterStyles.clearFiltersButton={
    variant: "secondary",
    css: css`
        float: right;
        border-radius: 24px;
    `,
}